import extractAttributes from '../Image/utils/extractAttributes';

const ALLOW = [
  'accelerometer',
  'autoplay',
  'clipboard-write',
  'encrypted-media',
  'gyroscope',
  'picture-in-picture',
  'web-share',
].join('; ');

type YoutubeProps = {
  video: string;
  height: number;
  width: number;
  start?: number;
  end?: number;
};

export default function Youtube({ video, height, width, start, end }: YoutubeProps) {
  return (
    <div className="mx-auto my-0" style={{ maxWidth: width }}>
      <iframe
        className="block w-full border-0"
        width={width}
        style={{ aspectRatio: width / height }}
        src={generateSrc(video, start, end)}
        title="YouTube video player"
        frameBorder="0"
        allow={ALLOW}
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export function getYoutubeProps(html: string): YoutubeProps {
  const attrs = extractAttributes(html);
  const height = parseInt(attrs.height ?? '500', 10);
  const width = parseInt(attrs.width ?? '800', 10);
  const start = parseInt(attrs.start ?? '0', 10);
  const end = parseInt(attrs.end ?? '0', 10);
  const video = attrs.video ?? '';

  return {
    height,
    width,
    start: start === 0 ? undefined : start,
    end: end === 0 ? undefined : end,
    video,
  };
}

function generateSrc(video: string, start?: number, end?: number) {
  const url = `https://www.youtube.com/embed/${video}`;
  const query: string[] = [];

  if (start) {
    query.push(`start=${start}`);
  }
  if (end) {
    query.push(`end=${end}`);
  }

  if (query.length > 0) {
    return `${url}?${query.join('&')}`;
  }

  return url;
}
